package er.prateek.crossly.ui.screens.math

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.geometry.Rect
import androidx.compose.ui.unit.dp
import er.prateek.crossly.ui.coach.CoachOverlay

/** One spotlighted region of a math-mode tour; [hole] is in root coordinates. */
data class ModeCoachStep(val title: String, val body: String, val hole: Rect)

/**
 * First-run tour for the math crossword and the riddles, built on the same [CoachOverlay] as the
 * word crossword's tour so all three share one look. Walks [steps] in order; [onFinish] reports
 * whether it ended by skipping and which step the player was on.
 */
@Composable
fun ModeCoachTour(
    steps: List<ModeCoachStep>,
    onFinish: (skipped: Boolean, stepIndex: Int) -> Unit,
) {
    var index by remember { mutableStateOf(0) }
    val step = steps[index.coerceIn(0, steps.lastIndex)]
    CoachOverlay(
        stepIndex = index,
        stepCount = steps.size,
        title = step.title,
        body = step.body,
        hole = step.hole,
        holeCornerRadius = 14.dp,
        onNext = { if (index >= steps.lastIndex) onFinish(false, index) else index++ },
        onSkip = { onFinish(true, index) },
    )
}
